export default __webpack_public_path__ + "static/1.1_EN-53dc3cc6672906304cfa457778333bd5.webp";